var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusWhiteBackPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#508CC0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20366 15.0769V5.47461H11.1142V15.0769H9.20366ZM5.36133 11.2275V9.31694H14.9636V11.2275H5.36133Z",
    fill: "#FDFDFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWhiteBackPrimary);
export default __webpack_public_path__ + "static/media/plus_white_back_primary.5b3ff0e5f6af6706153e5d5dc77888f2.svg";
export { ForwardRef as ReactComponent };